/** @jsx jsx */
import {
  Button,
  DownloadIcon,
  Flex,
  FullScreenModal,
  FullScreenModalContainer,
  FullScreenModalHeader,
  FullScreenModalHeading,
} from "@eworkit/iris";
import { useBreakpointIndex } from "@theme-ui/match-media";
import React, { FC } from "react";
import { useTranslation } from "react-i18next";
import { DialogStateReturn } from "reakit/Dialog";
import { jsx } from "theme-ui";

import { FilePreview } from "@/components/Files/preview/FilePreview";
import { useFilePreview } from "@/components/Files/preview/useFilePreview";
import { AttachmentLike } from "@/data/attachments";

export interface FilePreviewModalProps {
  attachment: AttachmentLike;
  modalState: DialogStateReturn;
  onDownloadButtonClick: (e: React.MouseEvent<HTMLButtonElement>) => void;
}

export const FilePreviewModal: FC<FilePreviewModalProps> = ({ attachment, modalState, onDownloadButtonClick }) => {
  const { t } = useTranslation(["public", "common"]);
  const breakpoint = useBreakpointIndex();

  const { activeAttachment } = useFilePreview({
    attachment: { file: attachment },
  });

  return (
    <FullScreenModal dialogState={modalState}>
      <FullScreenModalContainer sx={{ height: "100vh" }}>
        <FullScreenModalHeader
          onCloseClick={modalState.hide}
          closeButtonAriaLabel={t("session:COMPONENTS.PDF_PREVIEW.CLOSE")}
          sx={{
            "& > button": {
              alignSelf: "center",
            },
          }}>
          <Flex justifyContent="space-between" flexGrow={1} gap="sm" alignItems="center">
            <FullScreenModalHeading
              size="h-sm"
              sx={{
                lineClamp: 2,
                WebkitLineClamp: 2,
                display: "-webkit-box",
                overflow: "hidden",
                textOverflow: "ellipsis",
                WebkitBoxOrient: "vertical",
              }}>
              {attachment.name}
            </FullScreenModalHeading>
            {breakpoint >= 2 ? (
              <Button variant="secondary" size="sm" onClick={onDownloadButtonClick} iconLeft={<DownloadIcon />}>
                {t("session:COMPONENTS.PDF_PREVIEW.DOWNLOAD_FILE")}
              </Button>
            ) : (
              <Button variant="ghost" size="sm" onClick={onDownloadButtonClick} iconLeft={<DownloadIcon />} />
            )}
          </Flex>
        </FullScreenModalHeader>

        {activeAttachment && (
          <FilePreview attachment={activeAttachment} onDownloadButtonClick={onDownloadButtonClick} />
        )}
      </FullScreenModalContainer>
    </FullScreenModal>
  );
};
